import {NgModule} from '@angular/core';
import {PreloadAllModules, RouterModule, Routes} from '@angular/router';
import {PathEnum} from "./@application/enum/path.enum";
import {HomeComponent} from "./home/home.component";
import {ProfileComponent} from "./home/containers/profile/profile.component";
import {UnauthorizedComponent} from "../../projects/vendors/src/lib/components/unauthorized/unauthorized.component";
import {OngoingOrdersComponent} from "./home/containers/ongoing-orders/ongoing-orders.component";
import {PlaceOrderComponent} from "./home/containers/place-order/place-order.component";
import {TableOccupancyComponent} from "./home/containers/table-occupancy/table-occupancy.component";
import {canDeactivateGuard} from "../../projects/vendors/src/lib/guard/can-deactivate.guard";
import {DashBoardComponent} from './home/containers/dash-board/dash-board.component';
import {routerGuard} from "../../projects/vendors/src/lib/guard/router.guard";
import {PointOfSalesComponent} from "./home/containers/point-of-sales/point-of-sales.component";
import {AccessDeniedComponent} from "./home/components/access-denied/access-denied.component";
import {InitializingComponent} from "./home/components/initializing/initializing.component";

const routes: Routes = [
  {
    path: '',
    redirectTo: PathEnum.Auth,
    pathMatch: 'full'
  },
  {
    path: PathEnum.Auth,
    loadChildren: () => import('../../projects/auth/src/lib/auth.module').then(m => m.AuthModule)
  },
  {
    path: PathEnum.Initializing,
    component: InitializingComponent,
  },
  {
    path: PathEnum.Home,
    component: HomeComponent,
    data: {
      breadcrumb: 'Home'
    },
    children: [
      {
        path: PathEnum.DashBoard,
        canActivate: [routerGuard],
        component: DashBoardComponent,
        data: {
          breadcrumb: 'Home',
        }
      },
      {
        path: PathEnum.Settings,
        canActivate: [routerGuard],
        loadChildren: () => import('../../projects/settings/src/lib/settings.module').then(m => m.SettingsModule),
        data: {}
      },
      // {
      //   path: PathEnum.Materials,
      //   canActivate: [routerGuard],
      //   loadChildren: () => import('../../projects/inventory/src/lib/inventory.module').then(m => m.InventoryModule),
      //   data: {
      //   }
      // },
      {
        path: PathEnum.Items,
        canActivate: [routerGuard],
        loadChildren: () => import('../../projects/food/src/lib/food.module').then(m => m.FoodModule),
        data: {}
      },
      {
        path: PathEnum.Suppliers,
        canActivate: [routerGuard],
        loadChildren: () => import('../../projects/supplier/src/lib/supplier.module').then(m => m.SupplierModule),
        data: {
          allowedPermissions: ['SUPPLIER_VIEW']
        }
      },
      {
        path: PathEnum.Financials,
        canActivate: [routerGuard],
        loadChildren: () => import('../../projects/financial/src/lib/financial.module').then(m => m.FinancialModule),
        data: {}
      },
      {
        path: PathEnum.QrOrders,
        canActivate: [routerGuard],
        loadChildren: () => import('../../projects/qr-order/src/lib/qr-order.module').then(m => m.QrOrderModule),
        data: {}
      },
      {
        path: PathEnum.Reservations,
        canActivate: [routerGuard],
        loadChildren: () => import('../../projects/reservation/src/lib/reservation.module').then(m => m.ReservationModule),
        data: {}
      },
      {
        path: PathEnum.Reports,
        canActivate: [routerGuard],
        loadChildren: () => import('../../projects/reports/src/lib/reports.module').then(m => m.ReportsModule),
        data: {}
      },
      {
        path: PathEnum.Profile,
        component: ProfileComponent,
        data: {
          breadcrumb: 'Profile'
        }
      },
      {
        path: PathEnum.OtherOrders,
        canActivate: [routerGuard],
        loadChildren: () => import('../../projects/other-orders/src/lib/other-orders.module').then(m => m.OtherOrdersModule),
        data: {}
      },
      {
        path: PathEnum.OngoingOrders,
        canActivate: [routerGuard],
        component: OngoingOrdersComponent,
        data: {
          breadcrumb: 'Ongoing Orders',
          allowedPermissions: ['rpos:pos:order:view-status']
        }
      },
      {
        path: PathEnum.PlaceOrder,
        canDeactivate: [canDeactivateGuard],
        canActivate: [routerGuard],
        component: PlaceOrderComponent,
        data: {
          breadcrumb: 'Place Order',
        }
      },
      {
        path: PathEnum.PointOfSale,
        canActivate: [routerGuard],
        canDeactivate: [canDeactivateGuard],
        component: PointOfSalesComponent,
        data: {
          breadcrumb: 'Point Of Sale',
          allowedPermissions: ['rpos:pos:section:view']
        }
      },
      {
        path: PathEnum.TableOccupancy,
        canActivate: [routerGuard],
        component: TableOccupancyComponent,
        data: {
          breadcrumb: 'Table Occupancy',
        }
      },
      {
        path: PathEnum.Menu,
        canActivate: [routerGuard],
        loadChildren: () => import('../../projects/menu/src/lib/menu.module').then(m => m.MenuModule),
        data: {
          breadcrumb: 'Menu',
        }
      },
      {
        path: PathEnum.HumanResource,
        canActivate: [routerGuard],
        loadChildren: () => import('../../projects/human-resources/src/lib/human-resources.module').then(m => m.HumanResourcesModule),
        data: {
          breadcrumb: 'Human Resource',
          allowedPermissions: ['rpos:hr:section:view']
        }
      }

    ]
  },
  {
    path: PathEnum.Unauthorized,
    component: UnauthorizedComponent,
  },
  {
    path: PathEnum.AccessDenied,
    component: AccessDeniedComponent,
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes,
    {
      preloadingStrategy: PreloadAllModules
    })],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
